import { useFactors, foundationToStart } from "../state/FactorsContext";
import { scientific } from "../lib/format";
import LogSlider from "./LogSlider";

/**
 * The foundational denominator, made editable. Galaxies × stars-per-galaxy ×
 * planets-per-star = the number of planets the whole chain starts from. Letting
 * the reader move these shows how little the headline depends on the (enormous)
 * starting count — the filters dominate.
 */
export default function FoundationControls() {
  const { foundation, setFoundation, resetFoundation } = useFactors();
  const total = foundationToStart(foundation);

  return (
    <div className="rounded-2xl border border-white/10 bg-abyss/60 p-5 backdrop-blur-sm sm:p-6">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="font-display text-lg font-light text-white">
          The starting numbers
        </h3>
        <button
          type="button"
          onClick={resetFoundation}
          className="text-xs text-white/55 underline-offset-4 transition-colors hover:text-white/90 hover:underline"
        >
          ↺ Reset
        </button>
      </div>

      <div className="space-y-5">
        <LogSlider
          label="Galaxies in the universe"
          value={foundation.galaxies}
          min={1e11}
          max={3e12}
          onChange={(v) => setFoundation("galaxies", v)}
        />
        <LogSlider
          label="Stars per galaxy"
          value={foundation.starsPerGalaxy}
          min={1e9}
          max={4e11}
          onChange={(v) => setFoundation("starsPerGalaxy", v)}
        />
        <LogSlider
          label="Planets per star"
          value={foundation.planetsPerStar}
          min={0.5}
          max={20}
          onChange={(v) => setFoundation("planetsPerStar", v)}
        />
      </div>

      <div className="mt-5 border-t border-white/10 pt-4 text-center">
        <p className="text-[11px] uppercase tracking-[0.2em] text-white/55">
          Planets in the observable universe
        </p>
        <p className="mt-1 font-mono text-2xl text-cyan">{scientific(total)}</p>
      </div>
    </div>
  );
}
